import React, { useState, useEffect, ChangeEvent, useRef } from "react";
import "./component.css";
import {
  ADD_DOC_FILE,
  GET_ALL_ACCESSIBLE_DOCS,
  PATCH_USER_INFO,
  RESET_USER_PASSWORD,
} from "../utils/constants";
import {
  makeAuthenticatedGet,
  makeAuthenticatedPost,
  makeAuthenticatedPostForFile,
} from "../utils/fetchUtils";
import { useNavigate } from "react-router-dom";
import { Bounce, ToastContainer, toast } from "react-toastify";
import { DocData } from "../utils/types";
import uploadImg from "../assets/upload-img.svg";
import or from "../assets/or.svg";
import downArrow from "../assets/down-arrow.svg";
import useWindowWidth from "../utils/windowWidth";

// Define the type for form data
type FormDataType = {
  password: string;
  confirmPassword: string;
};

const ResetPasswordForm = (props: any) => {
  const navigate = useNavigate();

  const inputRef = useRef<HTMLInputElement>(null);

  // react states
  const [formData, setFormData] = useState<FormDataType>({
    password: "",
    confirmPassword: "",
  });
  const [isDirty, setIsDirty] = useState(false);
  const [error, setError] = useState<string>("");
  const [strength, setStrength] = useState(0);
  const [strengthLabel, setStrengthLabel] = useState("Weak");

  const checkPasswordStrength = (password) => {
    let strengthScore = 0;
    if (password.length >= 8) strengthScore += 25;
    if (/[A-Z]/.test(password)) strengthScore += 25;
    if (/[0-9]/.test(password)) strengthScore += 25;
    if (/[@$!%*?&]/.test(password)) strengthScore += 25;
    setStrength(strengthScore);
    if (strengthScore < 50) setStrengthLabel("Weak");
    else if (strengthScore < 75) setStrengthLabel("Medium");
    else setStrengthLabel("Strong");
  };
  // const handleOptionChange = (event: any) => {
  //   setSelectedOption(event.target.value);
  //   handleChange(event);
  // };

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));


    setError("");
    setIsDirty(false);

    if (name === "password") checkPasswordStrength(value);

    if (formData.password !== formData.confirmPassword) {
        setError("Passwords do not match.");
      setIsDirty(true);

    }

    

  };

  // Handle form submission
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    console.log(formData);

    // Validate inputs
    if (!formData.password || !formData.confirmPassword) {
        setError("Both fields are required.");
        setIsDirty(true);
        return;
      }
    // Process form data
    const formDataToSubmit = {"newPassword": formData.password};
    // Example: Sending data to an API
    console.log("Form Data:", formDataToSubmit);

    makeAuthenticatedPost(RESET_USER_PASSWORD, formDataToSubmit)
      .then((response) => {
        console.log(response);
        navigate('/profile');
      })
      .catch((error) => console.log(error));
  };

  //use Effects

  useEffect(() => {}, [formData]);

  //window size
  const windowWidth = useWindowWidth();
  const isMobile = windowWidth < 769;

  return (
    <>
      <form
        className="doc-form d-flex reset-password-form"
        onSubmit={handleSubmit}
        aria-live="polite"
        id="myForm"
      >
        <p style={{marginRight: 'auto' }}>
          Please enter your current password and new password to reset your
          password
        </p>
        <div className="input-div-container">
          <div
            className="input-container"
            style={{ width: isMobile ? "90%" : "55%" }}
          >
            <div className="mb-3 input-div input-div-10">
              <h2 id="new-password-label" className="form-label">
                New Password
              </h2>
              <input
                style={{ marginTop: "1rem",lineHeight:'3.5rem',borderColor: error ? "red" : "initial" }}
                className="form-control input-5"
                id="new-password"
                name="password"
                type="password"
                aria-label="password"
                value={formData.password}
                aria-labelledby="new-password-label"
                placeholder="new password"
                onChange={handleChange}
              ></input>
            </div>
          </div>
          <div
            className="input-container"
            style={{ width: isMobile ? "90%" : "55%" }}
          >
            <div className="mb-3 input-div input-div-10">
              <h2 id="confirm-password-label" className="form-label">
                Confirm Password
              </h2>
              <input
                style={{ marginTop: "1rem",lineHeight:'3.5rem',borderColor: error ? "red" : "initial" }}
                className="form-control input-5"
                id="confirm-password"
                name="confirmPassword"
                type="password"
                aria-label="confirm password"
                value={formData.confirmPassword}
                aria-labelledby="confirm-password-label"
                placeholder="confirm new password"
                onChange={handleChange}
              ></input>
              <div className="d-flex align-items-center" style={{ gap: "10px", marginTop: "10px" }}>
                <div className="progress-bar-container" style={{ flexGrow: 1, background: "#ddd", height: "8px", borderRadius: "4px", position: "relative", overflow: "hidden" }}>
                  <div
                    style={{
                      width: strength >= 75 ? "100%" : `${strength}%`,
                      height: "100%",
                      borderRadius: "4px",
                      background: strength < 50 ? "red" : strength < 75 ? "orange" : "green",
                      transition: "width 0.3s ease-in-out"
                    }}
                  ></div>
                </div>
                <p
                  style={{
                    fontWeight: "bold",
                    color: strength < 50 ? "red" : strength < 75 ? "orange" : "green",
                    minWidth: "70px",
                    textAlign: "center"
                  }}
                >
                  {strengthLabel}
                </p>
              </div>
            </div>
          </div>
          {error && (
          <p
            className="text-danger mt-2"
            role="alert"
            style={{
              color: "red",
              fontSize: "1rem",
              fontWeight: "bold"
            }}
          >
            {error}
          </p>
        )}
          <div
            style={{ width: "100%", paddingTop: "2rem" }}
            className="d-flex items-center"
          >
            <button
              type="submit"
              className="doc-submit"
              disabled={isDirty}
              form="myForm"
              style={{ borderRadius: "0.5rem",opacity:isDirty?'0.7':'1',cursor: isDirty ? "not-allowed" : "pointer" }}
            >
              Update Password
            </button>
          </div>
        </div>
      </form>
    </>
  );
};

export default ResetPasswordForm;
